import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import startOfMonth from "date-fns/startOfMonth";
import endOfMonth from "date-fns/endOfMonth";
import addMonths from "date-fns/addMonths";
import { useRef } from "react";
import { THEME } from "../theme/themeColors";

  export const predefinedBottomRanges = [
    { label: "Today", value: [new Date(), new Date()] },
    { label: "Yesterday", value: [addDays(new Date(), -1), addDays(new Date(), -1)] },
    { label: "This week", value: [startOfWeek(new Date()), endOfWeek(new Date())] },
    { label: "Last 7 days", value: [subDays(new Date(), 6), new Date()] },
    { label: "Last 30 days", value: [subDays(new Date(), 29), new Date()] },
    { label: "This month", value: [startOfMonth(new Date()), endOfMonth(new Date())] },
    { label: "Last month", value: [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))] },
    { label: "This year", value: [new Date(new Date().getFullYear(), 0, 1), new Date(new Date().getFullYear(), 11, 31)] },
    { label: "Last year", value: [new Date(new Date().getFullYear() - 1, 0, 1), new Date(new Date().getFullYear(), 0, 0)] },
    { label: "All time", value: [new Date(new Date().getFullYear() - 5, 0, 1), new Date()] },
  ];

  export const selectStyles = {
      control: (base) => ({
          ...base,
          minHeight: '30px',
          height: '30px',
          fontSize: '12px',
          borderColor: '#dee2e6',
          boxShadow: 'none',
          '&:hover': { borderColor: THEME.primary },
      }),
      valueContainer: (base) => ({ ...base, padding: '0 6px' }),
      indicatorsContainer: (base) => ({ ...base, padding: '0 2px' }),
      dropdownIndicator: (base) => ({ ...base, padding: '0 4px' }),
      option: (base, state) => ({
          ...base,
          fontSize: '12px',
          backgroundColor: state.isSelected ? THEME.primary : state.isFocused ? THEME.primaryLight : 'white',
          color: state.isSelected ? THEME.onPrimary : '#333',
          '&:active': { backgroundColor: THEME.primaryLight },
      }),
      singleValue: (base) => ({ ...base, fontSize: '12px' }),
      placeholder: (base) => ({ ...base, fontSize: '12px', color: '#adb5bd' }),
  };

     export const makeResizeHandlers = (widths, setWidths, activeIndexRef, startXRef, startWidthRef) => {
          const handleMouseMove = (e) => {
              if (activeIndexRef.current === null) return;
              const computedWidth = Math.max(60, startWidthRef.current + (e.clientX - startXRef.current));
              setWidths((prev) => {
                  const updated = [...prev];
                  updated[activeIndexRef.current] = computedWidth;
                  return updated;
              });
          };
          const handleMouseUp = () => {
              document.removeEventListener('mousemove', handleMouseMove);
              document.removeEventListener('mouseup', handleMouseUp);
              activeIndexRef.current = null;
              document.body.style.userSelect = '';
          };
          const handleMouseDown = (index, e) => {
              activeIndexRef.current = index;
              startXRef.current      = e.clientX;
              startWidthRef.current  = widths[index];
              document.body.style.userSelect = 'none';
              document.addEventListener('mousemove', handleMouseMove);
              document.addEventListener('mouseup', handleMouseUp);
          };
          return { handleMouseDown };
      };

     export const useColumnResizePct = (widths, setWidths, containerRef, minPct = 5) => {
          const activeIndex = useRef(null);
          const startX = useRef(0);
          const startWidths = useRef([]);

          const handleMouseDown = (index, e) => {
              e.preventDefault();
              if (index >= widths.length - 1) return;
              activeIndex.current = index;
              startX.current = e.clientX;
              startWidths.current = [...widths];

              const handleMouseMove = (moveEvent) => {
                  if (activeIndex.current === null || !containerRef.current) return;
                  const containerWidth = containerRef.current.offsetWidth;
                  if (!containerWidth) return;

                  const deltaPct = ((moveEvent.clientX - startX.current) / containerWidth) * 100;
                  const i = activeIndex.current;
                  const base = startWidths.current;

                  const next = base[i] + deltaPct;
                  const nextSibling = base[i + 1] - deltaPct;

                  if (next < minPct || nextSibling < minPct) return;

                  setWidths((prev) => {
                      const updated = [...prev];
                      updated[i] = next;
                      updated[i + 1] = nextSibling;
                      return updated;
                  });
              };

              const handleMouseUp = () => {
                  activeIndex.current = null;
                  document.removeEventListener('mousemove', handleMouseMove);
                  document.removeEventListener('mouseup', handleMouseUp);
              };

              document.addEventListener('mousemove', handleMouseMove);
              document.addEventListener('mouseup', handleMouseUp);
          };

          return { handleMouseDown };
      };